import { render, staticRenderFns } from "./pgregister.vue?vue&type=template&id=3e2955f9&scoped=true&"
import script from "./pgregister.vue?vue&type=script&lang=js&"
export * from "./pgregister.vue?vue&type=script&lang=js&"
import style0 from "./pgregister.vue?vue&type=style&index=0&id=3e2955f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2955f9",
  null
  
)

export default component.exports